import { get, post, put, destroy } from 'utils/fetchRequest';

/**
 * Public: хэрэглэгчээс ирсэн форм илгээх
 *
 * @param {object} data - { name, phone, email, message, recaptchaToken }
 */
export const submitInquiry = async (data) => {
    try {
        return await post('inquiries', data);
    } catch (err) {
        return { error: err };
    }
};

// ─── Admin ─────────────────────────────────────────
export const getInquiries = async (status, search, page, limit) => {
    try {
        const params = new URLSearchParams();
        if (status) params.set('status', status);
        if (search) params.set('search', search);
        if (page) params.set('page', page);
        if (limit) params.set('limit', limit);

        const qs = params.toString();
        return await get(`inquiries${qs ? `?${qs}` : ''}`);
    } catch (err) {
        return { error: err };
    }
};

export const getInquiryCounts = async () => {
    try {
        return await get('inquiries/counts');
    } catch (err) {
        return { error: err };
    }
};

export const getInquiry = async (id) => {
    try {
        return await get(`inquiries/${id}`);
    } catch (err) {
        return { error: err };
    }
};

export const updateInquiryStatus = async (id, status, adminNote) => {
    try {
        return await put(`inquiries/${id}/status`, { status, adminNote });
    } catch (err) {
        return { error: err };
    }
};

export const deleteInquiry = async (id) => {
    try {
        return await destroy(`inquiries/${id}`);
    } catch (err) {
        return { error: err };
    }
};
